import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './@theme/shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpAuthInterceptor } from './core/auth/http-auth-interceptor';
import { CoreModule } from './core/core.module';
import { AppSharedModule } from './shared/shared.module';
import { HomeComponent } from './home/home.component';
import { AppAuthModule } from './auth/app-auth.module';
import { ConfigService } from './core/config/config-service';
import { configFactory, ConfigFactoryProvider } from './core/config/functions';
import { ClipboardModule } from 'ngx-clipboard';
// import { UploadModule } from '@progress/kendo-angular-upload';
// import { EditorModule } from '@progress/kendo-angular-editor';
// import { DialogComponent } from './pages/page-details/dialog.component';
// import { DialogsModule } from "@progress/kendo-angular-dialog";
// import { InputsModule } from "@progress/kendo-angular-inputs";
// import { LabelModule } from "@progress/kendo-angular-label";



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    AppSharedModule,
    SharedModule,
    AppAuthModule,
    AppRoutingModule,
    // ClipboardModule,
    // EditorModule,
    // UploadModule,
    // DialogsModule,
    // InputsModule,
    // LabelModule
  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: 'API_URL', useFactory: ConfigFactoryProvider.getConfigFactory('api_url'), deps: [ConfigService],

    },
    //  {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DialogComponent,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
